import React from 'react'
import { Box } from '@mui/material'

interface Props {
    children: string | JSX.Element
    header: string | JSX.Element
}

const TextBoxTwoLines = ({ children, header }: Props) => {
    return (
        <Box
            sx={{
                flexDirection: 'column',
                display: 'flex',
                marginTop: '1rem',
            }}>
            <Box sx={{ fontWeight: '400', marginBottom: '0.5rem' }}>
                {header}
            </Box>
            {children}
        </Box>
    )
}
export default TextBoxTwoLines
